<template>
  <page title="消息">
    <cell subtitle="2020-2-20 14:33" url="#">系统赠送 </cell>
    <cell subtitle="2020-2-20 14:33" url="#">系统赠送 </cell>
    <cell subtitle="2020-2-20 14:33" url="#">系统赠送 </cell>
    <cell subtitle="2020-2-20 14:33" url="#">系统赠送 </cell>
    <cell subtitle="2020-2-20 14:33" url="#">系统赠送 </cell>
  </page>
</template>

<script>
export default {
  data(){
    return{
      
    }
  },
  methods:{},
  created(){}
}
</script>

<style lang='stylus'>

</style>